import { typedCollection, getCollection, where, orderBy } from '@/lib/firebase/firestore'
import type { FestivalDocument, FestivalEditionDocument } from '@/types'

const festivalsCol = () => typedCollection<FestivalDocument>('festivals')
const editionsCol = (festivalId: string) =>
  typedCollection<FestivalEditionDocument>(`festivals/${festivalId}/editions`)

export const festivalsService = {
  async getPublishedFestivals(): Promise<Array<FestivalDocument & { id: string }>> {
    return getCollection(festivalsCol(), where('isPublished', '==', true), orderBy('order', 'asc'))
  },

  async getFestivalBySlug(slug: string): Promise<(FestivalDocument & { id: string }) | null> {
    const results = await getCollection(
      festivalsCol(),
      where('slug', '==', slug),
      where('isPublished', '==', true)
    )
    return results[0] ?? null
  },

  async getEditions(festivalId: string): Promise<Array<FestivalEditionDocument & { id: string }>> {
    return getCollection(editionsCol(festivalId), where('isPublished', '==', true), orderBy('year', 'desc'))
  },
}
